module.exports = __webpack_public_path__ + "media/careers/careers_hardhat4-0486cb23.png";